module.exports = __webpack_public_path__ + "img/pin.e298dc76.svg";